function childPages() {
  if ( ($('.single-offer-child-pages .child-pages__link').hasClass("child-pages__link--active")) || ($('body').hasClass('tax-activity')) || ($('body').hasClass('tax-region')) ) {
    $(".menu-activities").addClass("display-underline");
  }

  if ( $('.about-us-child-pages .child-pages__link').hasClass("child-pages__link--active") ) {
    $(".about-us-menu").addClass("display-underline");
  }

}